import dynamic from 'next/dynamic'

import { TrackingContainer } from '@mc/visibility'

import { trackCatalogPageRowViewed } from '../../events'
import { usePageData } from '../PageDataProvider'

const StartYourJourneyToday = dynamic(
  import('components/StartYourJourneyToday').then(
    (m) => m.StartYourJourneyToday,
  ),
)
export const PlansSection = () => {
  const { slug } = usePageData()

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackCatalogPageRowViewed({
          rowName: 'start_your_journey',
          categorySlug: slug,
        })
      }
    >
      <StartYourJourneyToday
        trackProps={{
          category: slug,
        }}
      />
    </TrackingContainer>
  )
}
